import React from 'react';
import { Hero } from './components/Hero';
import { Letter } from './components/Letter';
import { Callout } from './components/Callout';
import { Features } from './components/Features';
import { Closing } from './components/Closing';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
export function App() {
  return <main className="overflow-hidden bg-cream" data-id="element-0">
      <Hero data-id="element-1" />
      <Letter data-id="element-2" />
      <Callout data-id="element-3" />
      <Features data-id="element-4" />
      <Closing data-id="element-5" />
      <Pricing data-id="element-6" />
      <Footer data-id="element-7" />
    </main>;
}